import {
  GET_BASIC_ERROR,
  GET_BASIC_SUCCESS,
  LOGIN_SUCCESS,
  SET_PROFILE_REDUCER,
} from "../types/authTypes";

const initState = {
  sentOtpSuccess: false,
  sentOtpError: false,
  sentOtpMsg: null,
};

const profileReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_BASIC_SUCCESS:
      return {
        ...state,
        basic: action.payload?.data,
      };
    case GET_BASIC_ERROR:
      return {
        ...state,
        basic: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        personId: action.payload.personId,
      };
    case SET_PROFILE_REDUCER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default profileReducer;
